import { Dialog, Stack, TextField } from '@all-manager/design-system-v2';
import ProviderAutocomplete from "../../../providers/external-components/ProviderAutocomplete/ProviderAutocomplete";
import { type AddPendingItemValues, useAddPendingItemModal } from "./useAddPendingItemModal";

type Props = {
  open: boolean;
  isAdding: boolean;
  onClose: () => void;
  onAdd: (params: AddPendingItemValues) => void;
  initialTitle?: string;
  initialProviderId?: string | null;
  initialProviderName?: string | null;
  /** `edit` renames the dialog and its action for an existing item. */
  mode?: 'create' | 'edit';
};

export default function AddPendingItemModal(props: Props) {
  const hook = useAddPendingItemModal(props);
  const isEdit = props.mode === 'edit';

  return (
    <Dialog
      open={props.open}
      onClose={hook.handleClose}
      onSubmit={hook.handleSubmit}
      maxWidth="sm"
      fullWidth
      title={isEdit ? "Modifier l'élément à suivre" : 'Ajouter un élément à suivre'}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: isEdit ? 'Enregistrer' : 'Ajouter',
          type: 'submit',
          disabled: !hook.isValid,
          loading: props.isAdding,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
        },
      }}
    >
      <Stack spacing={2}>
        <TextField
          fullWidth
          label="Élément à suivre"
          placeholder="Attente devis toiture, passage du technicien…"
          value={hook.title}
          onChange={(event) => hook.setTitle(event.target.value)}
          autoFocus
          required
        />
        <ProviderAutocomplete
          label="Prestataire (optionnel)"
          fullWidth
          value={hook.providerId}
          onChange={hook.setProviderId}
          onChangeText={hook.setProviderName}
          defaultSearch={props.initialProviderName || hook.providerName || undefined}
        />
      </Stack>
    </Dialog>
  );
}
